<template>
  <div class="app-page">
    <Header ref="header" helpURL="studio/datasets/">
      <template #header-slot>
        <BreadcrumbNavigation />
      </template>
      <template v-if="hasBreadcrumbSelectNavigation" #page-slot>
        <BreadcrumbSelectProjectAndDataset
          :hasDatasetNavigation="hasDatasetNavigation"
        />
      </template>
      <template v-else #extra-slot>
        <TaskEditModeCard
          v-if="mode === 'edit'"
          :annotationSetToEdit="annotationSetToEdit"
          :reviewSettings="reviewSettings"
          @update:annotation-set-to-edit="handleAnnotationSetToEditChanged"
          @stop-editing="handleStopEditing"
        />
      </template>
    </Header>
    <div class="main-page-div">
      <main
        id="drop-area"
        class="main-display-area"
      >
        <router-view />
      </main>
    </div>
    <TasksModal />
  </div>
</template>

<script setup>
import {
  computed, watch,
} from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import Header from '@/components/Header.vue';
import BreadcrumbNavigation from '@/components/BreadcrumbNavigation.vue';
import TaskEditModeCard from '@/components/DatasetComponent/AnnotationTool/TaskEditModeCard.vue';
import { useEditorStore } from '@/stores/useEditorStore.js';
import { useEditorTaskStore } from '@/stores/useEditorTaskStore.js';
import TasksModal from '@/components/TasksStatusComponent/TasksModalV2.vue';
import BreadcrumbSelectProjectAndDataset from '@/components/BreadcrumbSelectProjectAndDataset.vue';

const route = useRoute();

let {
  mode, annotationSetToEdit,
} = storeToRefs(useEditorStore());
let { reviewSettings } = storeToRefs(useEditorTaskStore());

watch(
  () => route.fullPath,
  (newPath) => {
    if (newPath.includes('/viewer')) {
      // Reinitialize stores
      const newEditorStore = useEditorStore();
      const newEditorTaskStore = useEditorTaskStore();

      // Re-import store refs
      ({
        mode, annotationSetToEdit,
      } = storeToRefs(newEditorStore));
      ({ reviewSettings } = storeToRefs(newEditorTaskStore));
    }
  },
  { immediate: true },
);

const hasBreadcrumbSelectNavigation = computed(() => !route.fullPath.includes('/viewer'));
const hasDatasetNavigation = computed(() => !route.fullPath.includes('/manager') && !route.fullPath.includes('/viewer'));

function handleAnnotationSetToEditChanged(set) {
  annotationSetToEdit.value = set;
  reviewSettings.value.reviewTask.source_annotation_set_id = set.id;
  reviewSettings.value.reviewTask.dest_annotation_set_id = set.id;
}

function handleStopEditing() {
  annotationSetToEdit.value = null;
  reviewSettings.value = null;
  mode.value = 'view';
}
</script>

<style lang="scss" scoped>

</style>
